import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import { Globals } from "../../../global/Globals";
export default function NotFound(){
    const navigate=useNavigate()
    return(<>
    <div className="Background-Page">
    <Header onlyPicture="true"/>
    <div className="Main" style={{display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"white",margin:"30px",padding:"10px",borderRadius:"10px",flexDirection:"column"}}>
        <img height={300} width={300} src={Globals.IMG.NOTFOUND}/>
        <img src={Globals.IMG.NOTFOUNDERROR}/>
        <button onClick={(()=>{navigate('/home')})}className={`basic-button`} style={{width:"200px",margin:"30px"}}>Return to Home Page</button>
        </div>
    <Footer/>
    </div>
    </>)
}